import { useState, useEffect } from 'react';
import { apiService } from '../services/api';

export interface SiteSettings {
  site_name: string;
  site_tagline: string;
  public_url: string;
  contact_email: string;
  default_meta_description: string;
  google_analytics_id: string;
  max_file_size: string;
  maintenance_mode: string;
  facebook_url: string;
  twitter_url: string;
  linkedin_url: string;
}

export const useSiteSettings = () => {
  const [settings, setSettings] = useState<SiteSettings>({
    site_name: 'Company Name',
    site_tagline: 'We are a dynamic company focused on innovation and growth.',
    public_url: '',
    contact_email: '',
    default_meta_description: '',
    google_analytics_id: '',
    max_file_size: '5',
    maintenance_mode: 'false',
    facebook_url: '',
    twitter_url: '',
    linkedin_url: '',
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        setLoading(true);
        const publicSettings = await apiService.getPublicSettings();
        
        // Convert array of settings to object
        const settingsObject: Partial<SiteSettings> = {};
        publicSettings.forEach(setting => {
          // Check if the setting key exists in our interface
          if (setting.key === 'site_name' || setting.key === 'site_tagline' || setting.key === 'public_url' ||
              setting.key === 'contact_email' || setting.key === 'default_meta_description' ||
              setting.key === 'google_analytics_id' || setting.key === 'max_file_size' ||
              setting.key === 'maintenance_mode' || setting.key === 'facebook_url' ||
              setting.key === 'twitter_url' || setting.key === 'linkedin_url') {
            settingsObject[setting.key as keyof SiteSettings] = setting.value;
          }
        });
        
        setSettings(prev => ({ ...prev, ...settingsObject }));
        setError(null);
      } catch (err) {
        console.error('Error fetching site settings:', err);
        setError('Failed to load site settings');
        // Keep default values if loading fails
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  return {
    settings,
    loading,
    error,
    siteName: settings.site_name,
    siteTagline: settings.site_tagline,
  };
};
